// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3X4EN","loginBlock":"Header_loginBlock__2g8g8"};